import { Box, useMediaQuery, useTheme } from "@mui/material";
import AdvancedReportHeader from "features/reports/AdvancedReport/AdvancedReportHeader";
import AdvancedReportProvider from "features/reports/AdvancedReport/AdvancedReportProvider";
import AdvancedReportChart from "features/reports/AdvancedReport/components/AdvancedReportChart";
import AdvancedReportPivotTable from "features/reports/AdvancedReport/components/AdvancedReportPivotTable";
import AdvancedReportToolbar from "features/reports/AdvancedReport/components/AdvancedReportToolbar";
import I18n from "i18n";
import CoordinatorReport3Filter from "./components/CoordinatorReport3Filter";
import CoordinatorReport3DataProvider from "./CoordinatorReport3DataProvider";

export default function CoordinatorReport3() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <CoordinatorReport3DataProvider visibleValues={["count", "guests"]}>
      <AdvancedReportHeader title={I18n.t("CoordinatorReport3.title")} />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          ml: isMobile ? -3 : 0,
          mr: isMobile ? -3 : 0,
          "& .MuiPaper-root": {
            borderRadius: isMobile ? 0 : undefined,
          },
        }}
      >
        <AdvancedReportProvider>
          <CoordinatorReport3Filter />
          <AdvancedReportToolbar />
          <AdvancedReportChart />
          <AdvancedReportPivotTable />
        </AdvancedReportProvider>
      </Box>
    </CoordinatorReport3DataProvider>
  );
}
